import { EntryListPlayer, GolfPlayer, QuarantinePlayer } from '@img-arena/consoles-api-dde'

import { StandarizedGolfPlayer } from './types'

const stringToNumber = (value: string | null) => {
  if (value === null) {
    return null
  }

  if (value === '') {
    return null
  }

  if (isNaN(Number(value))) {
    return null
  }

  return Number(value)
}

export const quarantinePlayerToStandarized = (player: QuarantinePlayer): StandarizedGolfPlayer => {
  const {
    id,
    name,
    etId,
    pgaId,
    lpgaId,
    livId,
    countryCode: country,
    randaId,
    dateOfBirth,
    gender,
    isAmateur
  } = player

  const { displayName, firstName, lastName } = name

  return {
    id,
    displayName,
    firstName,
    lastName,
    isAmateur,
    dateOfBirth,
    country,
    gender,
    etId: stringToNumber(etId),
    pgaId: stringToNumber(pgaId),
    lpgaId: stringToNumber(lpgaId),
    livId: stringToNumber(livId),
    randaId: stringToNumber(randaId)
  } satisfies StandarizedGolfPlayer
}

export const ddePlayerToStandarized = (player: GolfPlayer) => {
  const {
    playerId: id,
    displayName,
    firstName,
    lastName,
    isActive,
    isAmateur,
    dateOfBirth,
    country,
    gender,
    playerEuropeanTourId,
    playerLPGATourId,
    playerLivId,
    playerPGATourId,
    playerRandaId
  } = player.playerSummary

  return {
    id,
    displayName,
    firstName,
    lastName,
    isActive,
    isAmateur,
    dateOfBirth,
    country,
    gender,
    etId: stringToNumber(playerEuropeanTourId),
    etRanking: player.europeanTourRanking,
    lpgaId: stringToNumber(playerLPGATourId),
    livId: stringToNumber(playerLivId),
    pgaId: stringToNumber(playerPGATourId),
    randaId: stringToNumber(playerRandaId)
  }
}

export const entryListPlayerToStandarized = (player: EntryListPlayer): StandarizedGolfPlayer => {
  const {
    playerId: id,
    displayName,
    firstName,
    lastName,
    isAmateur,
    country,
    playerEuropeanTourId,
    playerPGATourId,
    playerLPGATourId,
    playerRandAId: playerRandaId
  } = player

  return {
    id,
    displayName,
    firstName,
    lastName,
    isAmateur,
    dateOfBirth: null,
    country,
    gender: null,
    etId: stringToNumber(playerEuropeanTourId),
    pgaId: stringToNumber(playerPGATourId),
    lpgaId: stringToNumber(playerLPGATourId),
    livId: null,
    randaId: stringToNumber(playerRandaId)
  }
}
